(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-popup"]) return;
  try {
    
  $(document).ready(function(){

    if(!$('.form-post-success').length && sessionStorage.getItem("dhProductPopupDisable") == null && localStorage.getItem("dhProductPopupDisable") == null){
      setTimeout(function(){
        //$('.product-popup-wrapper').fadeIn();
        sessionStorage.setItem("dhProductPopupDisable", true);
      }, 10000);
    }
    
    /*$('.product-popup-wrapper').on('click', function(){
      $('.product-popup-wrapper').fadeOut();
    });*/
    
    $('.product-popup-wrapper-close').on('click', function(){
      $('.product-popup-wrapper').fadeOut();
    });
    
    /*$('.product-popup-inner-wrapper').on('click', function (e) {
      e.stopPropagation();
    });*/

    /*if($('.form-post-success').length){
      $('.product-popup-wrapper').fadeIn();
    }*/

    if($('.form-post-success').length){
        localStorage.setItem("dhProductPopupDisable", true);
    }

    $('input[name="contact[consent_to_contact]"]').on('change', function(){
      
      if($(this).val() == "yes"){
        $('#consent_to_contact_details').show();
      }else{
        $('#consent_to_contact_details').hide();
      }
      
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"]) return;
  try {
    
  $(document).ready(function(){
    $('.write-review-button').on('click', function(){
      $('.product-review-wrapper').fadeIn();
    });
    
    $('.product-review-wrapper').on('click', function(){
      $('.product-review-wrapper').fadeOut();
    });
    
    $('.product-review-wrapper-close').on('click', function(){
      $('.product-review-wrapper').fadeOut();
    });
    
    $('.product-review-inner-wrapper').on('click', function (e) {
      e.stopPropagation();
    });

    if($('.form-post-success').length){
      $('.product-review-wrapper').fadeIn();
      $('.product-review-header h2').text('Thank you for your feedback!');
      $('.product-review-thumbnail').hide();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
